import axios from "axios";

const authClient = axios.create({
  baseURL: process.env.REACT_APP_AUTH_DOMAIN,
});

export function authServiceSignIn({ email, password }) {
  return authClient.post("/api/basic/signin", {
    connection: process.env.REACT_APP_AUTH_CONNECTION,
    connection_id: process.env.REACT_APP_AUTH_CONNECTION_ID,
    username: email,
    password,
  });
}

export function authServiceSignOut({ sessionId, sessionExpiration }) {
  return authClient.get("/api/basic/signout", {
    headers: {
      "session-id": sessionId,
      "session-expiration": sessionExpiration,
    },
    // Logout waits on this call — a hung network must never trap the user.
    timeout: 5000,
  });
}

export function fetchMe() {
  return axios.get("/partner/api/v1/me");
}

export function fetchInvite({ uuid, token }) {
  return axios.get(`/partner/api/v1/public/invite/${uuid}`, { params: { token } });
}

export function activateInvite({ uuid, token, password, confirm_password }) {
  return axios.post(`/partner/api/v1/public/invite/${uuid}/activate`, {
    token,
    password,
    confirm_password,
  });
}
